import React, { useEffect } from "react"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { CenteredLoadingIndicator } from "#/components/views/molecules/Molecules"
import { useSprintsCandidacyQuery } from "#/services/user/hooks/useSprintsQuery"

export default function DoAnyApplyCheckInDecisionStep(): JSX.Element {
  const sprintsCandidacyQuery = useSprintsCandidacyQuery()
  const memberIsSprintsCandidate = sprintsCandidacyQuery.data?.memberIsSprintsCandidate ?? false
  const partnerIsSprintsCandidate = sprintsCandidacyQuery.data?.partnerIsSprintsCandidate ?? false

  const { send } = useStateMachine()
  useEffect(() => {
    if (!sprintsCandidacyQuery.isFetching) {
      if (memberIsSprintsCandidate) {
        send("SPRINTS_MEMBER")
      } else if (partnerIsSprintsCandidate) {
        send("SPRINTS_PARTNER")
      } else {
        send("")
      }
    }
  }, [sprintsCandidacyQuery.isFetching, send, memberIsSprintsCandidate, partnerIsSprintsCandidate])

  return <CenteredLoadingIndicator />
}
